import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import SubmitButton from '../SubmitButton/.';
import MediaQuery from "react-responsive";

const styles = () => ({
    root: {
        fontSize: 16,
    },
    modalHeader: {
        borderBottom: "none",
        textAlign: "center",
        color: "#12a1e1",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: "1rem 1rem",
        borderTopLeftRadius: "calc(.3rem - 1px)",
        borderTopRightRadius: "calc(.3rem - 1px)",
    },
    modalBody: {
        backgroundColor: "#def2fb",
        margin: "0 1.5em",
        color: "#858b8c",
        position: "relative",
        flex: "1 1 auto",
        padding: "1rem",
    },
    modalFooter: {
        borderTop: "none",
        width: "60%",
        margin: "0 auto",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: ".75rem",
        borderBottomRightRadius: "calc(.3rem - 1px)",
        borderBottomLeftRadius: "calc(.3rem - 1px)",
    },

    modalTitle: {
        width: "100%",
        marginBottom: 0,
        lineHeight: "1.5",
        color: "#00A4E4",
        fontFamily: 'AIGFutura_Book',
        fontSize: "2em",
        fontWeight: "bolder",
    },
    modalCloseButton: {
        position: "absolute",
        right: "1rem",
        color: "#23abe3",
        backgroundColor: "#ddf1fa !important",
        padding: "0 .2em 0 .2em !important",
        fontSize: "230%",
        textShadow: "0 1px 0 #fff",
        opacity: ".5",
        lineHeight: "1",
        float: "right",
        border: 0,
        appearance: "none",
        cursor: "pointer",
        margin: "-1rem -1rem -1rem auto",
        "&:focus": {
            outline: "none",
        },
    },

    backdrop: {
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: "1040",
        width: "100vw",
        height: "100vh",
        backgroundColor: "#000",
        opacity: 0,
        transition: "opacity .15s linear",
    },
    modal: {
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: "1050",
        display: "none",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        outline: 0,
    },
    modalOpen: {
        overflowX: "hidden",
        overflowY: "auto",
        display: "block",
    },
    modalDialog: {
        position: "relative",
        width: "auto",
        margin: ".5rem",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        minHeight: "calc(100% - 1rem)",
        transition: "transform .3s ease-out,-webkit-transform .3s ease-out",
        transform: "none",
        maxWidth: 800,
    },
    modalContent: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pointerEvents: "auto",
        backgroundColor: "#fff",
        backgroundClip: "padding-box",
        border: "1px solid rgba(0,0,0,.2)",
        borderRadius: ".3rem",
        outline: 0,
    },
});

interface PassInProperty {
    classes: any,
    show: boolean,
    header_title: string,
    footer_string: string,
    allow_dangerously_set_innerhtml_on_title: string,
    allow_dangerously_set_innerhtml_on_content: string,
    onClickContent: Function,
    onHide: any
}

@withStyles(styles)    
class MotisVerticallyCenteredModal extends React.Component<PassInProperty>{
    
    render(){
    
            const {
                classes,
                show,
                header_title,
                content_string,
                footer_string,
                allow_dangerously_set_innerhtml_on_title,
                allow_dangerously_set_innerhtml_on_content,
                onClickContent,
                onHide
            } = this.props;

            return (
                <div className={`${classes.root} motis-vertically-centered-modal`}>
                    <MediaQuery query="(min-width: 576px)">
                        <style>{`
                            .modal-dialog {
                                margin: 1.75rem auto;
                                min-height: calc(100% - 3.5rem);
                            }
                        `}</style>
                    </MediaQuery>


                    <MediaQuery query="(max-width: 48em)">
                        <style>{`
                            .motis-vertically-centered-modal > div {
                                font-size: 0.8em;
                            }
                        `}</style>
                    </MediaQuery>

                    <div className={`${classes.backdrop}`} style={{display: show ? "block" : "none", opacity: ".5"}}></div>

                    <div className={`${classes.modal} ` + (show ? `${classes.modalOpen}`: ``)}>
                        <div className={`${classes.modalDialog} modal-dialog`}>
                            <div className={`${classes.modalContent}`}>
                                <div className={classes.modalHeader}>
                                    <div className={`${classes.modalTitle}`}>
                                        {typeof header_title === "object" ? (
                                            header_title
                                        ) : (
                                            allow_dangerously_set_innerhtml_on_title && allow_dangerously_set_innerhtml_on_title === 1 ? (
                                                <span dangerouslySetInnerHTML={{__html: header_title}} />
                                            ) : (
                                                <span>{header_title}</span>
                                            )
                                        )}
                                    </div>
                                    <button type="button" className={`${classes.modalCloseButton}`} onClick={onHide}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>

                                <div className={classes.modalBody} onClick={onClickContent}>
                                    {typeof content_string === "object" ? (
                                        content_string
                                    ) : (
                                        allow_dangerously_set_innerhtml_on_content && allow_dangerously_set_innerhtml_on_content == 1 ? (
                                            <p dangerouslySetInnerHTML={{__html: content_string}}></p>
                                        ) : (
                                            <p>
                                                {content_string}
                                            </p>
                                        )
                                    )}
                                </div>

                                <div className={classes.modalFooter}>
                                    {footer_string ? (
                                        <SubmitButton
                                            title={footer_string}
                                            onClickEvent={onHide}
                                        />
                                    ) : (
                                        <SubmitButton
                                            label="default_error_modal_ok"
                                            onClickEvent={onHide}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
}
export default MotisVerticallyCenteredModal;